export default {
  registration: {
    chapter: '1',
    component: 'helmi-section',
    props: {
      label: 'Lainhuuto / Vuokraoikeuden kirjaus',
    },
    children: {
      registrationAgreed: {
        chapter: '1.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kenelle lainhuuto myönnetty / Vuokraoikeus kirjattu',
          type: 'text',
        },
        value: null,
      },
    },
  },

  planning: {
    chapter: '2',
    component: 'helmi-section',
    props: {
      label: 'Kaavoitus ja lisätiedot',
    },
    children: {
      planning_1: {
        chapter: '2.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Asemakaava',
        },
        value: 'Ei',
      },

      planning_2: {
        chapter: '2.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Ranta-asemakaava',
        },
        value: 'Ei',
      },

      planning_3: {
        chapter: '2.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Yleiskaava',
        },
        value: 'Ei',
      },

      planning_4: {
        chapter: '2.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Yleiskaava/oikeusvaikutteinen',
        },
        value: 'Ei',
      },

      planning_5: {
        chapter: '2.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Suunnittelutarvealue',
        },
        value: 'Ei',
      },

      planning_6: {
        chapter: '2.6',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Rakennuslupa',
        },
        value: 'Ei',
      },

      planning_7: {
        chapter: '2.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Poikkeamispäätös',
        },
        value: 'Ei',
      },

      planning_8: {
        chapter: '2.8',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Rakennuskielto',
        },
        value: 'Ei',
      },

      planning_9: {
        chapter: '2.9',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Toimenpidekielto',
        },
        value: 'Ei',
      },

      planning_10: {
        chapter: '2.10',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Lopputarkastus',
        },
        value: 'Ei',
      },

      planning_11: {
        chapter: '2.11',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Käyttöönottotarkastus',
        },
        value: 'Ei',
      },

      ownShore: {
        chapter: '2.12',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Omaa rantaviivaa',
          type: 'text',
        },
        value: null,
      },

      shoreRight: {
        chapter: '2.13',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Rantaoikeus',
          type: 'text',
        },
        value: null,
      },

      waterAreaRight: {
        chapter: '2.14',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Oikeus vesialueisiin',
          type: 'text',
        },
        value: null,
      },

      frontOfShore: {
        chapter: '2.15',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Rannan edessä vesijättöä',
          type: 'text',
        },
        value: null,
      },
    },
  },

  encumberance: {
    chapter: '3',
    component: 'helmi-section',
    props: {
      label: 'Rasitteet',
    },
    children: {
      encumberance_1: {
        chapter: '3.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kiinteistön / vuokraoikeuden rasitteet',
          type: 'text',
        },
        value: null,
      },
      encumberance_2: {
        chapter: '3.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Maankäytön tai kohteen käyttö- tai luovutusrajoitukset ym.',
          type: 'text',
        },
        value: null,
      },
    },
  },

  water: {
    chapter: '4',
    component: 'helmi-section',
    props: {
      label: 'Käyttövesi',
    },
    children: {
      water_1: {
        chapter: '4.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kunnan',
        },
        value: 'Ei',
      },
      water_2: {
        chapter: '4.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kaivo',
        },
        value: 'Ei',
      },
      water_3: {
        chapter: '4.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Porakaivo',
        },
        value: 'Ei',
      },
      water_4: {
        chapter: '4.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muu',
        },
        value: 'Ei',
      },
      water_5: {
        chapter: '4.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Vesiosuuskunnan osakas',
        },
        value: 'Ei',
      },
    },
  },

  sewage: {
    chapter: '5',
    component: 'helmi-section',
    props: {
      label: 'Jätevesihuolto',
    },
    children: {
      sewage_1: {
        chapter: '5.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kunnan',
        },
        value: 'Ei',
      },
      sewage_2: {
        chapter: '5.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Umpisäiliö',
        },
        value: 'Ei',
      },
      sewage_3: {
        chapter: '5.3',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Saostuskaivo',
        },
        value: 'Ei',
      },
      sewage_4: {
        chapter: '5.4',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Maahanimeyttämö',
        },
        value: 'Ei',
      },
      sewage_5: {
        chapter: '5.5',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Maasuodattamo',
        },
        value: 'Ei',
      },
      sewage_6: {
        chapter: '5.6',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Selvitys',
        },
        value: 'Ei',
      },
      sewage_7: {
        chapter: '5.7',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Pienpuhdistamo',
        },
        value: 'Ei',
      },
      sewage_8: {
        chapter: '5.8',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Suunnitelma',
        },
        value: 'Ei',
      },
      sewage_9: {
        chapter: '5.9',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Käyttö- ja huolto-ohjeet',
        },
        value: 'Ei',
      },
    },
  },
  roads: {
    chapter: '6',
    component: 'helmi-section',
    props: {
      label: 'Tiestö',
    },
    children: {
      roads_1: {
        chapter: '6.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Tie perille',
        },
        value: 'Ei',
      },
      roads_2: {
        chapter: '6.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Tiemaksut',
          type: 'text',
        },
        value: null,
      },
    },
  },

  connections: {
    chapter: '7',
    component: 'helmi-section',
    props: {
      label: 'Liittymät',
    },
    children: {
      electricity: {
        chapter: '7.1',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Sähköliittymä siirtyy',
        },
        value: 'Ei',
      },
      otherConnections: {
        chapter: '7.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muita siirtyviä liittymiä',
          type: 'text',
        },
        value: null,
      },
    },
  },

  plans: {
    chapter: '8',
    component: 'helmi-section',
    props: {
      label: 'Rakentamiseen, kaavoitukseen tai liikennejärjestelyihin liittyvät suunnitelmat',
    },
    children: {
      plans_1: {
        chapter: '8.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kohteen tai sen naapurikiinteistöjen tai lähialueen suunnitelmat, viranomaismenettelyt tai vastaavat',
          type: 'text',
        },
        value: null,
      },
    },
  },

  otherBuildings: {
    chapter: '9',
    component: 'helmi-section',
    props: {
      label: 'Muut rakennukset',
    },
    children: {
      otherBuildings_1: {
        chapter: '9.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut rakennukset (esim. ulkovarasto, autotalli)',
          type: 'text',
        },
        value: null,
      },
    },
  },

  renovations: {
    chapter: '10',
    component: 'helmi-section',
    props: {
      label: 'Tehdyt korjaukset, muut toimenpiteet ja luvat',
    },
    children: {
      renovations_1: {
        chapter: '10.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantajan/aiempien omistajien kohteeseen teettämät/tekemät korjaukset/remontit ja muutostyöt, sekä niiden ajankohta ja korjauksen laajuus',
          type: 'text',
        },
        value: null,
      },
      renovations_2: {
        chapter: '10.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Onko rakennusvavontaviranomaiselta haettu / saatu lupa',
        },
        options: ['Kyllä', 'Ei', 'Ei tiedossa'],
        value: null,
      },
      renovations_3: {
        chapter: '10.3',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Lopputarkastus tehty',
        },
        options: ['Kyllä', 'Ei', 'Ei tiedossa'],
        value: null,
      },
      renovations_4: {
        chapter: '10.4',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Em. toimenpiteisiin liittyvät suunnitelmat ja asiakirjat ovat toimeksiantajalla',
        },
        options: ['Kyllä', 'Ei', 'Ei tiedossa'],
        value: null,
      },
      renovations_5: {
        chapter: '10.5',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Ilmoitetut pinta-alat tarkistusmitattu',
        },
        options: ['Kyllä', 'Ei', 'Ei tiedossa'],
        value: null,
      },
    },
  },

  heating: {
    chapter: '11',
    component: 'helmi-section',
    props: {
      label: 'Lämmitysjärjestelmä',
    },
    children: {
      heating_1: {
        chapter: '11.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Lämmitysjärjestelmän kunto ja lisätiedot',
          type: 'text',
        },
        value: null,
      },
    },
  },

  humidityMetering: {
    chapter: '12',
    component: 'helmi-section',
    props: {
      label: 'Kosteusmittaus / kuntotarkastus',
    },
    children: {
      humidityMetering_1: {
        chapter: '12.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Suoritettu kosteusmittaus / kuntotarkastus',
          type: 'text',
        },
        value: null,
      },
    },
  },

  damage: {
    chapter: '13',
    component: 'helmi-section',
    props: {
      label: 'Viat ja puutteet',
    },
    children: {
      clientKnowsOrSuspects: {
        chapter: '13.1',
        classes: 'text-subtitle-2',
        component: 'helmi-title',
        props: {
          label: 'Toimeksiantaja tietää tai epäilee, että rakennuksessa on',
        },
      },

      waterDamage: {
        chapter: '13.1.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Sattunut vesivahinko',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      moistureDamage: {
        chapter: '13.1.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Kosteusvaurioita',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      moldOrFungus: {
        chapter: '13.1.3',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Home- tai sieniongelma',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      otherDamageOrDeficiencies: {
        chapter: '13.1.4',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muita erityisiä vahinkoja, vikoja tai puutteita',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },

      additionalInfoOfTheDeficiencies: {
        chapter: '13.1.5',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          hint: 'Vahingon ajankohta, laajuus, syy jne.',
          label: 'Lisätietoja vioista ja puutteista',
        },
        value: null,
      },
    },
  },

  disadvantages: {
    chapter: '14',
    component: 'helmi-section',
    props: {
      label: 'Asumisviihtyvyyteen vaikuttavat tekijät',
    },
    children: {
      disadvantages_1: {
        chapter: '14.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Asumisviihtyvyyteen vaikuttavat tekijät (esim. melu, haju, tärinä, kuumuus, kylmyys, veto, tuhoeläimet, jyrsijät)',
          type: 'text',
        },
        value: null,
      },
    },
  },

  included: {
    chapter: '15',
    component: 'helmi-section',
    props: {
      label: 'Muuta kauppaan kuuluvaa',
    },
    children: {
      included_1: {
        chapter: '15.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muuta kauppaan kuuluvaa',
          type: 'text',
        },
        value: null,
      },
    },
  },

  notIncluded: {
    chapter: '16',
    component: 'helmi-section',
    props: {
      label: 'Kauppaan ei kuulu',
    },
    children: {
      notIncluded_1: {
        chapter: '16.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kauppaan ei kuulu',
          type: 'text',
        },
        value: null,
      },
    },
  },

  mortgages: {
    chapter: '17',
    component: 'helmi-section',
    props: {
      label: 'Kiinnitykset ja rasitteet',
    },
    children: {
      mortgages_1: {
        chapter: '17.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kiinnitykset',
          type: 'text',
        },
        value: null,
      },
      mortgages_2: {
        chapter: '17.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Vapaana olevat kiinnitykset',
          type: 'text',
        },
        value: null,
      },
      mortgages_3: {
        chapter: '17.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Panttivastuiden euromäärä',
          type: 'number',
          suffix: '€',
        },
        value: null,
      },
      mortgages_4: {
        chapter: '17.4',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        props: {
          label: 'Panttikirjojen säilytyspaikka',
          type: 'text',
        },
        value: null,
      },
    },
  },

  otherEncumberances: {
    chapter: '18',
    component: 'helmi-section',
    props: {
      label: 'Kirjatut muut rasitukset, rasitteet ja hallinnanrajoitukset',
    },
    children: {
      otherEncumberances_1: {
        chapter: '18.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Kirjattu hallinnanjakosopimus',
        },
        options: ['Kyllä', 'Ei'],
        value: null,
      },
    },
  },

  unpaidExpenses: {
    chapter: '19',
    component: 'helmi-section',
    props: {
      label: 'Maksamattomat maksut',
    },
    children: {
      unpaidExpenses_1: {
        chapter: '19.1',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantajan mukaan kiinteistöllä ei ole maksamattomia maksuja tai toimeksiantajan tiedossa olevia kustannuksia / myöhemmin aiheutuvia velvoitteita.',
        },
        options: ['On', 'Ei ole'],
        value: 'Ei ole',
      },
      unpaidExpenses_2: {
        chapter: '19.1.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        condition: {
          item: 'unpaidExpenses_1',
          type: '=',
          value: 'On',
        },
        props: {
          label: 'Lisätietoa (maksut, kustannukset ja velvoitteet)',
          type: 'text',
        },
        value: null,
      },
      unpaidExpenses_4: {
        chapter: '19.2',
        component: 'helmi-radiogroup',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja on ilmoittanut kaikki sellaiset kiinteistöön kohdistuvat maksamattomat maksut, rasitukset, rasitteet sekä hallinnanrajoitukset, jotka eivät ilmene lainhuuto-, kiinnitys- ja kiinteistörekisteristä.',
        },
        options: ['On', 'Ei ole'],
        value: 'On',
      },
      unpaidExpenses_5: {
        chapter: '19.2.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
        },
        condition: {
          item: 'unpaidExpenses_4',
          type: '=',
          value: 'Ei ole',
        },
        props: {
          label: 'Lisätietoa (maksut, rasitteet ja rasitukset)',
          type: 'text',
        },
        value: null,
      },

    },
  },
  energyCertificate: {
    chapter: '20',
    component: 'helmi-section',
    props: {
      label: 'Energiatodistus',
    },
    children: {
      energyCertificate_6: {
        chapter: '20.1',
        component: 'helmi-title',
        classes: 'text-subtitle-2',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantaja ymmärtää, että rakennuksen omistajana hänen on hankittava myytävästä kohteesta lain edellyttämä energiatodistus ja siinä olevia tietoja käytetään myyntitilanteessa. (Laki energiatodistuksesta 2§).',
        },
      },

      energyCertificate_7: {
        chapter: '20.2',
        component: 'helmi-checkbox',
        container: {
          cols: 12,
        },
        props: {
          label: 'Toimeksiantajaa kehoitettu hankkimaan lain vaatima energiatodistus',
        },
        value: 'Ei',
      },
    },
  },
  keys: {
    chapter: '21',
    component: 'helmi-section',
    props: {
      label: 'Avaimet',
    },
    children: {
      numberOfKeys: {
        chapter: '21.1',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Toimeksiantajan hallussa olevia käyttölukon avaimia',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      securityLock: {
        chapter: '21.2',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Turvalukon avainten lukumäärä',
          suffix: 'kpl',
          type: 'number',
        },
        value: null,
      },

      otherKeys: {
        chapter: '21.3',
        component: 'helmi-text-field',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Muut avaimet',
          type: 'text',
        },
        value: null,
      },

      agentReceivedKeyData: {
        chapter: '21.4',
        component: 'helmi-date-picker',
        container: {
          cols: 12,
          md: 6,
        },
        props: {
          label: 'Välittäjä vastaanottanut avaimen',
          type: 'text',
          appendIcon: 'today',
        },
        value: null,
      },
    },
  },

  otherImportantInfo: {
    chapter: '22',
    component: 'helmi-section',
    props: {
      label: 'Muut kaupan kannalta merkittävät tiedot ja lisätiedot',
    },
    children: {
      includedInTheDeal: {
        chapter: '22.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Muut kaupan kannalta merkittävät tiedot ja lisätiedot',
        },
        value: null,
      },
    },
  },

  attachments: {
    chapter: '23',
    component: 'helmi-section',
    props: {
      label: 'Liitteet',
    },
    children: {
      attachments_1: {
        chapter: '23.1',
        component: 'helmi-textarea',
        container: {
          cols: 12,
        },
        props: {
          label: 'Liitteet',
        },
        value: null,
      },
    },
  },
};
